export const NAV_OPEN_EVENT = 'onboarding-open-nav';
export const NAV_EXPAND_GROUP_EVENT = 'onboarding-reveal-nav-target';

export function getAttrFromTarget(target) {
  if (typeof target !== 'string') return null;
  const m = target.match(/data-onboarding="([^"]+)"/);
  return m?.[1] ?? null;
}

export function openNavForTour() {
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent(NAV_OPEN_EVENT));
  }
}

/**
 * Просим NavBar самому найти пункт по data-onboarding-атрибуту и показать
 * его — где бы он сейчас ни лежал после персональной настройки меню
 * (Фаза 2): раскрыть тот раздел, куда его перенесли, а если пользователь
 * его спрятал — временно показать на время тура. NavBar знает актуальное
 * расположение (renderMenu), поэтому вся логика внутри него, а не здесь —
 * никакой статической карты «атрибут → раздел» больше нет.
 */
export function revealNavTarget(attr) {
  if (typeof window !== 'undefined' && attr) {
    window.dispatchEvent(new CustomEvent(NAV_EXPAND_GROUP_EVENT, { detail: { attr } }));
  }
}

export function prepareNavStepBefore(target) {
  const attr = getAttrFromTarget(target);
  openNavForTour();
  if (attr) revealNavTarget(attr);
  const delay = attr ? 420 : 320;
  return new Promise((r) => setTimeout(r, delay));
}
